<template>
  <div ref="icons" class="icons-container" :style="{ left: left + 'px', top: top + 'px' }">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'FloatIcons',
  props: {
    // 滚动id
    scroller: {
      type: String,
      default: ''
    },
    // 距离上有下左的安全距离
    padding: {
      type: String,
      default: '10 10 10 10'
    },
    // 初始位置距离底部的距离
    bottom: {
      type: Number,
      default: 160
    }
  },
  data() {
    return {
      timer: null,
      currentTop: 0,
      clientWidth: 0,
      clientHeight: 0,
      itemWidth: 0,
      itemHeight: 0,
      left: null,
      top: null,
      isDragging: false,
      animationTimer: null,
      animationActive: false
    }
  },
  computed: {
    // 滚动对象，默认空返回window
    scrollContainer() {
      if (this.scroller === '') {
        return window
      } else {
        return document.getElementById(this.scroller)
      }
    },
    // 安全距离
    safeArea() {
      return this.padding.split(' ')
    }
  },
  created() {
    // 屏幕宽度
    this.clientWidth = document.documentElement.clientWidth
    // 屏幕高度
    this.clientHeight = document.documentElement.clientHeight
  },
  mounted() {
    this.$nextTick(() => {
      // 获取滚动元素
      this.scrollContainer.addEventListener('scroll', this.handleScrollStart)
      const div = this.$refs.icons
      // 获取宽度
      this.itemWidth = this.$refs.icons.offsetWidth
      this.itemHeight = this.$refs.icons.offsetHeight
      // 设置位置
      this.left = this.clientWidth - this.itemWidth - this.safeArea[1]
      this.top = this.clientHeight - this.itemWidth - this.bottom
      
      // 添加窗口大小变化监听
      window.addEventListener('resize', this.handleResize)
      
      // 启用拖拽功能
      this.enableDragging(div)
      
      // 添加动画效果
      this.startAttentionAnimation()
    })
  },
  beforeDestroy() {
    this.scrollContainer.removeEventListener('scroll', this.handleScrollStart)
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize)
    
    // 清除动画定时器
    if (this.animationTimer) {
      clearInterval(this.animationTimer)
      clearTimeout(this.animationTimer)
    }
  },
  methods: {
    // 滚动时候执行
    handleScrollStart() {
      if (this.isDragging) return
      
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.handleScrollEnd()
      }, 300)
      this.currentTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.left > this.clientWidth / 2) {
        this.left = this.clientWidth - this.itemWidth / 2
      } else {
        this.left = -this.itemWidth / 2
      }
    },
    handleScrollEnd() {
      if (this.isDragging) return
      
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop === this.currentTop) {
        if (this.left > this.clientWidth / 2) {
          this.left = this.clientWidth - this.itemWidth - this.safeArea[1]
        } else {
          this.left = this.safeArea[3]
        }
        clearTimeout(this.timer)
      }
    },
    // 处理窗口大小变化
    handleResize() {
      // 更新屏幕尺寸
      this.clientWidth = document.documentElement.clientWidth
      this.clientHeight = document.documentElement.clientHeight
      
      // 重新计算位置
      if (this.left > this.clientWidth / 2) {
        // 如果在右侧，保持在右侧
        this.left = this.clientWidth - this.itemWidth - this.safeArea[1]
      } else {
        // 如果在左侧，保持在左侧
        this.left = this.safeArea[3]
      }
      
      // 确保不超出底部边界
      const maxTop = this.clientHeight - this.itemHeight - this.safeArea[2]
      if (this.top > maxTop) {
        this.top = maxTop
      }
    },
    
    // 启用拖拽功能
    enableDragging(element) {
      // 防止图片和内容被拖拽
      const preventDrag = (e) => {
        e.preventDefault();
        return false;
      };
      
      // 为所有子元素添加防拖拽
      element.querySelectorAll('*').forEach(el => {
        el.addEventListener('dragstart', preventDrag);
      });
      
      // 为元素本身添加防拖拽
      element.addEventListener('dragstart', preventDrag);
      
      let startX, startY, startLeft, startTop
      let isDragStarted = false
      let moveDistance = 0
      
      // 鼠标事件（PC端）
      element.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return // 只响应左键点击
        this.isDragging = true
        element.style.transition = 'none'
        startX = e.clientX
        startY = e.clientY
        startLeft = this.left
        startTop = this.top
        isDragStarted = false
        moveDistance = 0
        
        const handleMouseMove = (e) => {
          if (!this.isDragging) return
          
          const deltaX = e.clientX - startX
          const deltaY = e.clientY - startY
          moveDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)
          
          // 判断是否开始拖拽（移动超过5px）
          if (moveDistance > 5) {
            isDragStarted = true
          }
          
          this.left = this.constrainX(startLeft + deltaX)
          this.top = this.constrainY(startTop + deltaY)
        }
        
        const handleMouseUp = () => {
          if (!this.isDragging) return
          
          this.isDragging = false
          element.style.transition = 'all 0.3s'
          
          // 如果拖动了，执行贴边
          if (isDragStarted) {
          this.snapToEdge()
          }
          
          document.removeEventListener('mousemove', handleMouseMove)
          document.removeEventListener('mouseup', handleMouseUp)
        }
        
        document.addEventListener('mousemove', handleMouseMove)
        document.addEventListener('mouseup', handleMouseUp)
      })
      
      // 触摸事件（移动端）
      element.addEventListener('touchstart', (e) => {
        this.isDragging = true
        element.style.transition = 'none'
        startX = e.touches[0].clientX
        startY = e.touches[0].clientY
        startLeft = this.left
        startTop = this.top
        isDragStarted = false
        moveDistance = 0
      })
      
      element.addEventListener('touchmove', (e) => {
        if (!this.isDragging) return
        
        const deltaX = e.touches[0].clientX - startX
        const deltaY = e.touches[0].clientY - startY
        moveDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)
        
        // 判断是否开始拖拽（移动超过5px）
        if (moveDistance > 5) {
          isDragStarted = true
        }
        
        if (isDragStarted) {
        this.left = this.constrainX(startLeft + deltaX)
        this.top = this.constrainY(startTop + deltaY)
          e.preventDefault() // 只有确认拖拽时才阻止默认行为
        }
      }, { passive: false })
      
      element.addEventListener('touchend', () => {
        if (!this.isDragging) return
        
        this.isDragging = false
        element.style.transition = 'all 0.3s'
        
        // 如果拖动了，执行贴边
        if (isDragStarted) {
        this.snapToEdge()
        }
      })
    },
    
    // 约束X坐标在安全区域内
    constrainX(x) {
      return Math.max(
        parseInt(this.safeArea[3]),
        Math.min(x, this.clientWidth - this.itemWidth - parseInt(this.safeArea[1]))
      )
    },
    
    // 约束Y坐标在安全区域内
    constrainY(y) {
      return Math.max(
        parseInt(this.safeArea[0]),
        Math.min(y, this.clientHeight - this.itemHeight - parseInt(this.safeArea[2]))
      )
    },
    
    // 贴靠到最近的边缘
    snapToEdge() {
      // 如果更接近右侧，贴靠到右侧
      if (this.left > this.clientWidth / 2) {
        this.left = this.clientWidth - this.itemWidth - parseInt(this.safeArea[1])
      } else {
        // 否则贴靠到左侧
        this.left = parseInt(this.safeArea[3])
      }
    },
    
    // 启动注意力动画
    startAttentionAnimation() {
      // 随机间隔触发动画
      const scheduleNextAnimation = () => {
        const randomDelay = Math.floor(Math.random() * 10000) + 15000 // 15-25秒之间随机
        this.animationTimer = setTimeout(() => {
          this.playAttentionAnimation()
          scheduleNextAnimation()
        }, randomDelay)
      }
      
      // 初始延迟后开始第一次动画
      this.animationTimer = setTimeout(() => {
        scheduleNextAnimation()
      }, 5000)
    },
    
    // 播放注意力动画
    playAttentionAnimation() {
      if (this.animationActive || this.isDragging) return
      
      this.animationActive = true
      const element = this.$refs.icons
      
      // 添加动画类
      element.classList.add('attention-animation')
      
      // 动画结束后移除类
      setTimeout(() => {
        element.classList.remove('attention-animation')
        this.animationActive = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.icons-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  width: 44px;
  height: 44px;
  padding: 0;
  z-index: 1000;
  transition: all 0.3s;
  cursor: move;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  overflow: visible;
  
  &:hover {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2);
  }
}

@keyframes attention-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-10px);
  }
  40% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-5px);
  }
  80% {
    transform: translateY(0);
  }
}

.attention-animation {
  animation: attention-bounce 1s ease;
}
</style>